import React, { memo } from 'react'
import { Link } from '@tanstack/react-router'
import { HighlightedText } from './HighlightedText'

interface ProjectItemProps {
    title: string
    code?: string | null
    description?: string | null
    id: string
    highlights?: {
        title?: string[]
        description?: string[]
    }
    onClick?: () => void
}

export const ProjectItem = memo(({ title, code, description, highlights, onClick, id }: ProjectItemProps) => {
    return (
        <Link
            to="/projects/$id"
            params={{
                id: id,
            }}
            className="group flex items-start gap-2.5 py-3 hover:bg-neutral-50 dark:hover:bg-neutral-800 rounded-md px-2"
            onClick={onClick}
        >
            <img src="/svg/note.svg" alt="Project" className="size-5" />

            <div className="flex flex-col min-w-0 flex-1 gap-2">
                <div className="flex items-center justify-between gap-2">
                    <HighlightedText
                        text={title}
                        highlight={highlights?.title}
                        className="text-sm font-medium text-foreground truncate leading-5 group-hover:underline"
                    />
                    <HighlightedText text={code} className="text-sm font-medium text-foreground truncate leading-5" />
                </div>
                <HighlightedText
                    text={description}
                    highlight={highlights?.description}
                    className="text-xs font-normal text-neutral-500 leading-4"
                />
            </div>
        </Link>
    )
})

ProjectItem.displayName = 'ProjectItem'
